<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">
                          
                        &nbsp;&nbsp;查詢時間:<ejs-datepicker id="datepicker" style='text-align:center' format="yyyy-MM-dd" width='150px' v-model="e_b_date" ></ejs-datepicker>
                        ~<ejs-datepicker id="datepicker" format="yyyy-MM-dd" style='text-align:center' width='150px' v-model="e_e_date" ></ejs-datepicker>
                        &nbsp;<ejs-button cssClass="e-info" v-on:click.native='search' style="margin-bottom: 5px;">查詢</ejs-button>
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>                               
                                  <e-column field='bar_code_no' headerText='條碼編號' width='180'></e-column>         
                                  <e-column field='lon_lat' headerText='掃描區域' width='220'></e-column>          
                                  <e-column field='create_date' headerText='掃描時間' width='160'></e-column>       
                                  <e-column field='next_url' headerText='瀏覽位置' width='140'></e-column>    
                                  <e-column field='url' headerText='瀏覽位置' width='220'></e-column>              
                                  <e-column field='ip' headerText='IP位置' width='180'></e-column>
                                  <e-column field='is_mobile' headerText='是否手機' width='200'></e-column>                               
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>           
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin  } from '@syncfusion/ej2-vue-buttons';    
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars"
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";


setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
        'Print': '列印',
        'Search': '搜尋'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(TextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(DatePickerPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(Loading);

let Loader      = undefined;

export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent
  },
  data: function () {
    return {
      e_selectRow : null,  
      e_b_date: null, e_e_date: null,
      e_buttons: [
        {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ],

      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      datas: null,
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,

      toolbar : 
      [ { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'],

      imgPersonTemplate: function () { return { 
          template: Vue.component("imgPersonTemplate", {
          template:  `<div><div class="e-grid-empimg"><img :src="image" class='c-avatar-about-img' style='width:30px' /></div></div>`,
              data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
          computed: {
              image: function() {
                  return this.data.img_url;
              }
          }
      })}},
    };
  },
  methods: {    
    toolbarClick: function (args) {     
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'部門資料.xlsx' });
      }   
    },   
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },     
    
    rowSelected: function(args) {    
      this.e_selectRow = args.row.getAttribute('aria-rowindex');  
      this.e_state = args.data.state == 1; 
      this.checkHeader();
    },   
    recordDoubleClick: function () {         
      this.e_isAdd = false;
      this.$refs.modalDialog.show();  
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    search: function() {
      this.getOfficial()
    },
    getOfficial: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `AppManager/Official?b=${this.e_b_date.toISOString().split('T')[0]}&e=${this.e_e_date.toISOString().split('T')[0]}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.e_selectRow = null;
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.e_b_date = new Date();
    this.e_e_date = new Date();
    this.getOfficial();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}
</style>
<style lang="scss" src="../../scss/base.scss"></style>
